/**
 * Single source of truth for business details.
 * Change a value here and it updates everywhere on the site.
 */

export const site = {
  name: 'Pramukh Jewellers',
  tagline: 'Since 1997',
  since: 1997,
  legal: 'Pramukh Jewellers',
  positioning: 'Antique · Bridal · Diamond Jewellers',

  phoneDisplay: '+91 99044 50916',
  phone: '+919904450916',
  whatsapp: '919904450916',
  email: 'Pramukhjewellers91@yahoo.com',

  address: {
    line1: 'Fortune Business Hub, 7',
    line2: 'Science City Road, Sola',
    city: 'Ahmedabad',
    state: 'Gujarat',
    pin: '380060',
    full: 'Fortune Business Hub, 7, Science City Rd, Sola, Ahmedabad, Gujarat 380060',
  },

  hours: [{ days: 'Monday – Saturday', time: '10:00 AM – 7:00 PM' }],

  social: {
    instagram: 'https://www.instagram.com/pramukhjewellers?igsh=aTE5NGhlNW1ydXd1',
    facebook: 'https://www.facebook.com/share/1EGXMCNExV/?mibextid=wwXIfr',
    maps: 'https://maps.app.goo.gl/m3x3BYXpBfGfbtT76?g_st=ic',
  },

  // Google Maps embed for the Science City Road showroom.
  // `z` is the zoom level — 18 sits tight on the building so the unit is easy
  // to identify. Raise toward 20 to zoom further in, drop to ~15 for context.
  mapEmbed:
    'https://www.google.com/maps?q=Fortune+Business+Hub,+Science+City+Road,+Sola,+Ahmedabad,+Gujarat+380060&z=18&output=embed',

  offer: {
    active: true,
    headline: 'Flat 6.99% Making Charges',
    note: '30th Anniversary Month Offer',
  },
};

export const brand = {
  markBlue: '/assets/brand/mark-blue.png',
  markGold: '/assets/brand/mark-gold.png',
  markWhite: '/assets/brand/mark-white.png',
  wordmarkBlue: '/assets/brand/wordmark-blue.png',
  wordmarkGold: '/assets/brand/wordmark-gold.png',
  wordmarkWhite: '/assets/brand/wordmark-white.png',
  horizontalBlue: '/assets/brand/logo-horizontal-blue.png',
  horizontalWhite: '/assets/brand/logo-horizontal-white.png',
  stackedBlue: '/assets/brand/logo-stacked-blue.png',
  stackedGold: '/assets/brand/logo-stacked-gold.png',
  stackedWhite: '/assets/brand/logo-stacked-white.png',
  master: '/assets/brand/logo-master.jpg',
  qrInstagram: '/assets/brand/qr-instagram.png',
  qrLocation: '/assets/brand/qr-location.png',
};

export const nav = [
  { label: 'Home', to: '/' },
  { label: 'Collections', to: '/collections' },
  { label: 'Reels', to: '/reels' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

/**
 * Enquiry-gate thresholds.
 *
 * GATE_AFTER_DETAIL_PHOTOS = 2 means the prompt appears on the **3rd photo**
 * the visitor opens in the full-screen product viewer.
 *
 * The scroll threshold is a much longer backstop for someone who only browses
 * thumbnails: a desktop grid shows three at once, so a low number here would
 * fire the modal on page load.
 */
export const GATE_AFTER_DETAIL_PHOTOS = 2;
export const GATE_AFTER_SCROLLED_PHOTOS = 11;

export const buildWhatsAppLink = ({ name = '', mobile = '', interest = '', message = '' } = {}) => {
  const lines = [
    `Namaste ${site.name} 🙏`,
    '',
    'I would like to enquire about your jewellery.',
    name && `Name: ${name}`,
    mobile && `Mobile: ${mobile}`,
    interest && `Interested in: ${interest}`,
    message && `Message: ${message}`,
  ].filter(Boolean);

  return `https://wa.me/${site.whatsapp}?text=${encodeURIComponent(lines.join('\n'))}`;
};
